import type { Dispatch } from "@reduxjs/toolkit";
import KolulaStorageManager from "../storage/KolulaStorageManager";
import { personalDataCleared } from "../redux/slice/bookingCreation/bookingCreationSlice";

/**
 * H-3a scenario 4 (#1873): forget the booking form's personal data on every
 * account-session END — explicit logout (AccountPage), GDPR delete completion
 * (DeleteAccountSection) and the 401 session-expiry paths (axiosNewBaseQuery
 * `/me*` branch, useAccountSessionInit). Otherwise the previous user's PII
 * (prefilled via `personalDataHydrated` from the account profile) survives in
 * Redux AND in the IndexedDB draft and shows up for the next user of the
 * device.
 *
 * Clears both stores the draft lives in: the bookingCreation slice (Redux)
 * and the IDB draft (`KolulaStorageManager.deletePersonalData`). The IDB
 * delete is async — fire-and-forget with a swallow, a failed delete must
 * never break the logout / 401 path.
 *
 * Guests are untouched by design: this is only called from session-END events,
 * which a never-logged-in guest cannot trigger (no token, no `/me*` calls),
 * so guest draft persistence behaves exactly as before.
 */
export const clearBookingPersonalData = (dispatch: Dispatch): void => {
  dispatch(personalDataCleared());
  new KolulaStorageManager().deletePersonalData().catch(() => {
    // IDB unavailable or delete failed — non-fatal, Redux is already cleared.
  });
};

export default clearBookingPersonalData;
